import { store } from '@/store/store';
import { GetCookieByName } from '../Cookies/CookieHelper';

export function GetSelectedCountryCookie() {
    return GetCookieByName(store.state.cookieContract.countryCode);
}

export function GetNoPreloginRedirectCookie() {
    return GetCookieByName(store.state.cookieContract.noPreloginRedirect);
}
// The pre-login page persists the selected country BEFORE submitting so the dropdown restores on a reload. This is the
// only app cookie the SPA authors; its lifetime and posture come from the server cookie contract (never hardcoded here)
// so a client-authored country cookie is identical to the one the server writes during login.
export function SetSelectedCountryCookie(selectedCountry: any) {
  if (selectedCountry == null)
    return;

  const write = store.state.cookieContract.countryCodeWrite;
  let cookie = `${store.state.cookieContract.countryCode}=${selectedCountry.abbreviation};path=${write.path};max-age=${write.maxAgeSeconds}`;
  if (write.secure)
    cookie += ';secure';
  if (write.sameSite && write.sameSite.toLowerCase() !== 'unspecified')
    cookie += `;samesite=${write.sameSite}`;
  document.cookie = cookie;
}
